const fileUploader = [
  {
    title: "Label",
    type: "input",
    name: "label",
    required: true,
    description:
      "A short label explaining to the user what this file uploader is for.",
  },
  {
    title: "Allowed file extensions",
    type: "tag",
    name: "type",
    required: false,
    description: 'Allowed file extensions. (e.g. "png", "jpg", "mp4", etc.).',
  },
  {
    title: "Allow multiple files",
    type: "checkbox",
    name: "accept_multiple_files",
    required: false,
    description: "Allows the user to upload multiple files at the same time.",
  },
  {
    title: "Help message",
    type: "input",
    name: "help",
    required: false,
    description: "A tooltip that gets displayed next to the file uploader.",
  },
];

const textInput = [
  {
    title: "Label",
    type: "input",
    name: "label",
    required: true,
    description: "A short label explaining to the user what this input is for.",
  },
  {
    title: "Max number of characters",
    type: "number",
    name: "max_chars",
    required: false,
    description:
      "Max number of characters allowed in text input. (should be > 0)",
  },
  {
    title: "Help message",
    type: "input",
    name: "help",
    required: false,
    description: "An optional tooltip that gets displayed next to the input.",
  },
  {
    title: "Placeholder",
    type: "input",
    name: "placeholder",
    required: false,
    description: "An optional string displayed when the text input is empty.",
  },
];

const textArea = [
  {
    title: "Label",
    type: "input",
    name: "label",
    required: true,
    description: "A short label explaining to the user what this input is for.",
  },
  {
    title: "Max number of characters",
    type: "number",
    name: "max_chars",
    required: false,
    description:
      "Maximum number of characters allowed in text area. (should be > 0)",
  },
  {
    title: "Help message",
    type: "input",
    name: "help",
    required: false,
    description:
      "An optional tooltip that gets displayed next to the textarea.",
  },
  {
    title: "Placeholder",
    type: "input",
    name: "placeholder",
    required: false,
    description: "An optional string displayed when the text input is empty.",
  },
];

const slider = [
  {
    title: "Label",
    type: "input",
    name: "label",
    required: true,
    description:
      "A short label explaining to the user what this slider is for.",
  },
  {
    title: "Value",
    type: "number",
    name: "value",
    required: false,
    description: "The value of the slider when it first renders.",
  },
  {
    title: "Step",
    type: "number",
    name: "step",
    required: false,
    description: "The stepping interval. (default is 1)",
  },
  {
    title: "Minimum value",
    type: "number",
    name: "min_value",
    required: false,
    description: "The minimum permitted value. (default is 0)",
  },
  {
    title: "Maximum value",
    type: "number",
    name: "max_value",
    required: false,
    description: "The maximum permitted value. (default is 100)",
  },
  {
    title: "Help message",
    type: "input",
    name: "help",
    required: false,
    description: "An optional tooltip that gets displayed next to the slider.",
  },
];

const checkbox = [
  {
    title: "Label",
    type: "input",
    name: "label",
    required: true,
    description:
      "A short label explaining to the user what this checkbox is for.",
  },
  {
    title: "Value",
    type: "checkbox",
    name: "value",
    required: false,
    description: "Preselect the checkbox when it first renders.",
  },
  {
    title: "Help message",
    type: "input",
    name: "help",
    required: false,
    description:
      "An optional tooltip that gets displayed next to the checkbox.",
  },
];

const radio = [
  {
    title: "Label",
    type: "input",
    name: "label",
    required: true,
    description:
      "A short label explaining to the user what this radio group is for.",
  },
  {
    title: "Options",
    type: "tag",
    name: "options",
    required: true,
    description: "Labels for the radio options.",
  },
  {
    title: "Preselected Option Index",
    type: "number",
    name: "index",
    required: false,
    description: "The index of the preselected option on first render. (should be >= 0)",
  },
  {
    title: "Help message",
    type: "input",
    name: "help",
    required: false,
    description: "An optional tooltip that gets displayed next to the radio.",
  },
];

const multiSelect = [
  {
    title: "Label",
    type: "input",
    name: "label",
    required: true,
    description:
      "A short label explaining to the user what this select widget is for.",
  },
  {
    title: "Options",
    type: "tag",
    name: "options",
    required: true,
    description: "Labels for the select options.",
  },
  {
    title: "Default Selected Options",
    type: "tag",
    name: "default",
    required: false,
    description: "List of default values. (same as options)",
  },
  {
    title: "Help message",
    type: "input",
    name: "help",
    required: false,
    description: "An optional tooltip that gets displayed next to the multiselect.",
  },
]

export const inputWidgets = {
  fileUploader,
  textInput,
  textArea,
  slider,
  checkbox,
  radio,
  multiSelect
};
